module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "back-btn"
  }, [_c('svg-icon', {
    staticClass: "back-btn__arrow",
    attrs: {
      "icon": _vm.arrow,
      "width": 6,
      "height": 10
    }
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-118c9718"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/oldWorkbench/attributePanel/BackButton.vue
// module id = 1816
// module chunks = 0